import { ModuleModel } from '../../module.model.interface';

export class RoleDescriptor implements ModuleModel {
  public discriminator = 'RoleDescriptor';

  public id: string;
  public alias: string;
  public description: string;
  public systemRole: string;



  public roleType: string;

  public href: string;
  public modified: Date;
  public deleted: Date;

  constructor(options?: {
    id: string;
    alias: string;
    description: string;
    systemRole: string;
    roleType: string;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.alias = options.alias;
      this.description = options.description;
      this.systemRole = options.systemRole;
      this.roleType = options.roleType;
      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }

  }

  public setSystemRole(roles: Array<string>) {
    this.systemRole = roles.join(';');
  }

  public getSystemRoles(): Array<string> {
    if (this.systemRole) {
      return this.systemRole.split(';').filter(a => a.length > 0);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/role/model/role.ts